import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { useEffect, useState, useMemo } from "react";
import moment from "moment";
import SecondaryTable from "../../../../Tables/SecondaryTable/SecondaryTable";
import DoubleLine from "../../../../../../Components/DoubleLine/DoubleLine";
import BMXChip from "../../../../../../Components/Chip/BMXChip";
import { IconButton } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { FetchMethodType } from "../../../../../../Utils/GlobalVariables/Fetch/MethodsType";


const ServiceContinuationListFormStepOne = ({ initialValues }) => {
  const { t } = useTranslation();
  const [historyService, setHistoryService] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const { payload } = await GlobalAuthFetch({
        path: `/service/getListServiceHistory/${initialValues?.uuid}`,
        method: FetchMethodType.get,
      });
      setHistoryService(payload?.data);
    };

    if (initialValues?.uuid) {
      fetchData();
    }
  }, [initialValues?.uuid]);




  const openDetails = (el) => {
    window.open(
      `${origin}/#/dashboard/service/${el.uuid}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const mappedData = useMemo(
    () =>
      historyService.map((el) => ({
        index: el.index,
        createdAt: (
          <DoubleLine
            firstLine={moment(el.createdAt).format("DD-MM-YYYY")}
            secondLine={moment(el.createdAt).format("HH:mm")}
          />
        ),
        technician: `${el?.technicianOrTeamLeader?.firstName} ${el?.technicianOrTeamLeader?.lastName}`,
        status: <BMXChip
          size={"small"}
          label={el?.status?.name}
          font={el?.status?.color?.font}
          backgroundColor={el?.status?.color?.background}
        />,
        icons: (
          <IconButton onClick={() => openDetails(el)}>
            <ArrowForwardIcon className="text primary" sx={{ fontSize: 16 }} />
          </IconButton>
        ),
      })),
    [historyService],
  );

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <Row>
        <Col xs={12}>
          <SecondaryTable
            search={false}
            pagination={false}
            headers={[
              {
                key: "index",
                name: t("global:service.index"),
                width: "20%",
                sort: false,
              },
              {
                key: "createdAt",
                name: t("global:service.createdAt"),
                width: "20%",
                sort: false,
              },
              {
                key: "technician",
                name: t("global:service.technician"),
                width: "25%",
                sort: false,
              },
              {
                key: "status",
                name: t("global:service.status"),
                width: "25%",
                sort: false,
              },
              { key: "icons", name: "", width: "10%", sort: false },
            ]}
            data={mappedData}
          />
        </Col>
      </Row>
    </div >
  );
};
export default ServiceContinuationListFormStepOne;
